module.exports = __webpack_public_path__ + "img/car-blue.06154462.svg";